module.exports = __webpack_public_path__ + "9eebd09221c5774e597bba60940c37f7.pdf";